import { render, staticRenderFns } from "./CertificateLookupDate.vue?vue&type=template&id=61f56ba5&scoped=true"
import script from "./CertificateLookupDate.vue?vue&type=script&lang=js"
export * from "./CertificateLookupDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f56ba5",
  null
  
)

export default component.exports